import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ccfe1e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "empty-content"
};
const _hoisted_2 = {
  class: "description"
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Empty',
  props: {
    description: {
      default: '暂无数据',
      type: String
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SvgIcon, {
        "icon-class": "noData",
        class: "empty-icon"
      }), _createElementVNode("div", _hoisted_2, _toDisplayString(__props.description), 1)]);
    };
  }
});